import * as React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import TagLink from "../components/tagLink"

const CasesFilter = ({ selected, className }) => {
  const data = useStaticQuery(
    graphql`
      query casesFilterQuery {
        casesPostsPerSolutionGroup: allMarkdownRemark(
          limit: 2000
          filter: {
            frontmatter: { tags: { eq: "cases" } }
            fields: { meta: { draft: { eq: false } } }
          }
          sort: { fields: frontmatter___date, order: DESC }
        ) {
          group(field: frontmatter___solution) {
            fieldValue
          }
        }
        allMarkdownRemark(
          limit: 2000
          filter: { fields: { meta: { draft: { eq: false } } } }
        ) {
          group(field: frontmatter___tags) {
            fieldValue
          }
        }
        industryTags: allTagsJson(
          filter: { type: { eq: "industry" } }
          sort: { fields: priority, order: ASC }
        ) {
          nodes {
            name
            title
          }
        }
        allTagTypeJson {
          nodes {
            name
            title
          }
        }
        allSolutionJson {
          nodes {
            name
            title
          }
        }
      }
    `
  )

  const allUsedSolutions = data.casesPostsPerSolutionGroup.group
  const allSolution = data.allSolutionJson.nodes
  const industryTags = data.industryTags.nodes
  const allUsedTags = data.allMarkdownRemark.group
  const filterUsedTag = tagList => {
    return tagList.filter(obj => {
      return !!allUsedTags.find(tag => tag.fieldValue === obj.name)
    })
  }

  return (
    <div className={className}>
      <h3 className="text-textGray-100 w-full flex gap-1 lg:gap-3 items-center font-bold text-base lg:text-xl tracking-wide mb-4 lg:mb-6 after:block after:h-px after:flex-grow after:bg-brandGray">
        検索条件変更
      </h3>
      <h4 className="text-brandNavy font-bold text-sm mt-5 mb-4">
        ソリューションから絞り込む
      </h4>
      <div className="flex flex-wrap flex-gap-2 pb-5">
        {allUsedSolutions.map(solution => {
          const metaData = allSolution.find(
            obj => obj.name === solution.fieldValue
          )
          if (!metaData) return
          if (selected === solution.fieldValue) {
            return (
              <div
                key={solution.fieldValue}
                className={`text-white bg-brandNavy border border-brandNavy inline-block font-medium rounded-full text-sm py-1 px-3`}
              >
                {metaData.title}
              </div>
            )
          } else {
            return (
              <Link
                to={`/cases-${solution.fieldValue}`}
                key={solution.fieldValue}
                className={`text-blue-800 bg-blue-50 border border-blue-100 inline-block font-medium rounded-full hover:opacity-70 text-sm py-1 px-3`}
              >
                {metaData.title}
              </Link>
            )
          }
        })}
      </div>
      <h4 className="text-brandNavy font-bold text-sm mt-5 mb-4">
        業界から絞り込む
      </h4>
      <div className="flex flex-wrap flex-gap-2 pb-5 lg:pb-7">
        {filterUsedTag(data.industryTags.nodes).map(tag => (
          <TagLink
            name={tag.name}
            title={tag.title}
            key={`tag-list-${tag.name}`}
            size={"m"}
          />
        ))}
      </div>
    </div>
  )
}

export default CasesFilter
